import { Card } from "@components/common/ui/Card";
import { styled } from "@styles";
import { fadeInFromTop } from "@styles/animations";

export const Header = styled("div", {
  display: "flex",
  width: "100%",
  justifyContent: "space-between",
  alignItems: "center",
  gap: "$16px",
  marginBottom: "$24px",
});

export const Count = styled("div", {
  width: "$24px",
  height: "$24px",
  backgroundColor: "$neutral30",
  color: "$neutral70",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: "$rounded",
  fontSize: "$10px",
  fontWeight: "$bold",
  marginRight: "auto",
});

export const LogoContainer = styled("div", {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  gap: "$12px",
});

export const Container = styled("div", {
  display: "flex",
  flexWrap: "wrap",
  gap: "$24px",
  width: "100%",
});

export const OfferCard = styled(Card, {
  display: "flex",
  flexDirection: "column",
  gap: "$6px",
  minHeight: "unset",
  maxWidth: "$345px",
  opacity: 0,
  animation: `${fadeInFromTop} 0.1s ease-in-out`,
  animationFillMode: "both",
  animationDelay: "0.1s",
  variants: {
    disabled: {
      true: {
        display: "none",
      },
    },
  },
});

export const ContentCardRow = styled("div", {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  width: "100%",
});

export const Chargefrequency = styled("span", {
  maringLeft: "auto",
  fontWeight: "$regular",
});
